export const MAX_TAG_LEN = 22;
export const MIN_TAG_LEN = 3;
